module.exports = __webpack_public_path__ + "img/accRecycleIntr2.ced938db.png";